import { FC, useState } from "react";
import { IFormMakeSingleCall, TinitialValues } from "./FormMakeSingleCall.props";
import ModalFormWindow from "@/HOC/ModalFormWindow/ModalFormWindow";
import { INPUTS_LIST } from "./FormMakeSingleCall.const";
import { CustomTextField } from "@/ui";
import { useFormik } from "formik";
import * as Yup from "yup";
import { Box, Button } from "@mui/material";
import { useTranslate } from "@/hooks";
import { useSingleCallMutation } from "@/store/RTKQuery/clsSlice";
import NoticeSingleAction from "@/components/MUI/NoticeSingleAction/NoticeSingleAction";

const validationSchema = Yup.object({
	source: Yup.string().required().min(3),
	destination: Yup.string().required().min(3),
});

const initialValues: TinitialValues = {
	source: "",
	destination: "",
};

const FormMakeSingleCall: FC<IFormMakeSingleCall> = ({ showModal, setShowModal, title }) => {
	const [submitted, setSubmitted] = useState(false);
	const translate = useTranslate();
	const [singleCall] = useSingleCallMutation();
	const [showNotification, setShowNotification] = useState<boolean>(false); // показ уведомления
	const [snackbarMessage, setSnackbarMessage] = useState("");

	const formik = useFormik({
		initialValues,
		enableReinitialize: true,
		validateOnChange: submitted,
		validateOnBlur: submitted,
		validationSchema,
		onSubmit: (values) => {
			const serverDataFormat = {
				source: values.source,
				destination: values.destination,
				metadata: {},
			};
			singleCall({ callParams: serverDataFormat })
				.unwrap()
				.then((res) => {
					if (res.error === 0) {
						handleShowNotice("notice_callIsStarted");
						handleClose();
					} else if (res.error === 1) {
						handleShowNotice(`${translate("title_error")}: ${res.message}`);
					}
				})
				.catch((err) => {
					handleShowNotice(`${translate("title_error")}: ${JSON.stringify(err.error)}`);
				});
		},
	});

	const handleShowNotice = (message: string) => {
		setSnackbarMessage(message);
		setShowNotification(true);
	};

	const handleClose = () => {
		setShowModal(false);
		formik.resetForm();
	};
	const handleSubmit = () => {
		formik.handleSubmit();
		setSubmitted(true);
	};
	return (
		<>
			<ModalFormWindow showModal={showModal} setShowModal={setShowModal} headerTitle={title} close={handleClose}>
				<Box sx={{ display: "flex", flexDirection: "row", alignItems: "center", gap: "12px", flexWrap: "wrap", mt: "16px", justifyContent: "center" }}>
					<Box sx={{ display: "flex", flexDirection: "row", gap: "12px", width: "100%" }}>
						{INPUTS_LIST.map((el, i) => {
							const key = el.title as keyof TinitialValues;
							return (
								<CustomTextField
									key={key}
									type={el.type}
									name={key}
									autoFocus={i === 0}
									sx={{ width: "100%" }}
									onChange={formik.handleChange}
									label={translate(el.label)}
									value={formik.values[key]}
									required={true}
									onBlur={formik.handleBlur}
									error={Boolean(formik.errors[key])}
									touched={formik.touched[key]}
									// helperText={formik.touched[key] && formik.errors[key] ? formik.errors[key] : ""}
								/>
							);
						})}
					</Box>
					<Button variant="outlined" sx={{ fontSize: 11 }} fullWidth onClick={handleSubmit} disabled={!formik.isValid}>
						{translate("button_call")}
					</Button>
				</Box>
			</ModalFormWindow>
			<NoticeSingleAction
				severity={snackbarMessage.toLowerCase().includes("error") || snackbarMessage.toLowerCase().includes("ошибка") ? "error" : "info"}
				showNotification={showNotification}
				setShowNotification={setShowNotification}
				title={snackbarMessage}
			/>
		</>
	);
};

export default FormMakeSingleCall;
